import React from 'react';
import IconButton from '@mui/material/IconButton';
import styles from '../../../style.js';
import {getSignedFile,getApprovalFile, getAdditionalFile} from '../../NewProcess/apiRequestService';
import {DownloadFile, DownloadZipFile} from '../../../utils/fileOperation';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const COMPLETED_STATUS = 'Tamamlanan';

export const styleDownloadFileBtn = (id,status) => {
    const onClick = (e) => {
      debugger;
      e.stopPropagation();

    // Hem imzalanmış dosyayı hem de süreç dosyasını al
    Promise.all([getSignedFile(id), getApprovalFile(id), getAdditionalFile(id)])
        .then(([signedFileResponse, approvalFileResponse, additionalFileResponse]) => {
            const signedFile = signedFileResponse.data;
            const approvalFile = approvalFileResponse.data;
            const additionalFile = additionalFileResponse.data;

    // Mutlaka süreç dosyası var mı kontrolü yap
    if (!approvalFile) {
        throw new Error("Süreç dokümanı bulunamadı.");
    }

    const filesToDownload = [];

    if (approvalFile) filesToDownload.push({ ...approvalFile, type: "approval" });
    if (signedFile)   filesToDownload.push({ ...signedFile,   type: "signed" });
    if (additionalFile) filesToDownload.push({ ...additionalFile, type: "additional" });

    if (filesToDownload.length === 1) {
        // Sadece süreç dokümanı varsa
        DownloadFile(approvalFile.fileData, approvalFile.fileName);
    } else {
        // Ek veya imzalı varsa ziple indir
        DownloadZipFile(filesToDownload);
    }
})
.catch((exception) => {
  this.props.actions.setNotification("Dosya bilgileri getirilemedi, daha sonra tekrar deneyin.", 'error');
  console.error('styleDownloadFileBtn exception:', exception);
});
};

    return <IconButton onClick={onClick} style={styles.showButton}><FileDownloadIcon /></IconButton>
}